// GameCategories.jsx
import React from "react";
import { useHistory } from "react-router-dom";
import GamesNavbar from "./components/GamesNavbar";
import SceneBackground from "../components/scene/SceneBackground";
import { useTranslation } from "react-i18next";
import "./GameCategories.css";
import "../containers/ModalTheme.css";
import "../containers/GroupPageCards.css";
import { getStableAnimalEmoji } from "../utils/utils";
import { useScene } from "../components/scene/SceneContext";

const gameCategories = [
  {
    icon: "🪡",
    titleKey: "games.categories.items.jubensha.title",
    descriptionKey: "games.categories.items.jubensha.description",
    comingSoon: false,
    path: "/games/jubensha/new",
  },
  {
    icon: "♠️",
    titleKey: "games.categories.items.texas.title",
    descriptionKey: "games.categories.items.texas.description",
    comingSoon: false,
    path: "/games/texas/new",
  },
  {
    icon: "🐺",
    titleKey: "games.categories.items.werewolf.title",
    descriptionKey: "games.categories.items.werewolf.description",
    comingSoon: true,
  },
  {
    icon: "🎲",
    titleKey: "games.categories.items.board.title",
    descriptionKey: "games.categories.items.board.description",
    comingSoon: true,
  },
  {
    icon: "🃏",
    titleKey: "games.categories.items.card.title",
    descriptionKey: "games.categories.items.card.description",
    comingSoon: true,
  },
  {
    icon: "🎯",
    titleKey: "games.categories.items.trivia.title",
    descriptionKey: "games.categories.items.trivia.description",
    comingSoon: true,
  },
];

export default function GameCategories() {
  const { t } = useTranslation();
  const history = useHistory();
  const mascot = getStableAnimalEmoji("game-categories");
  const { variant } = useScene();

  const handleCategoryClick = (category) => {
    if (!category.comingSoon) {
      if (category.path) {
        history.push(`${process.env.PUBLIC_URL}${category.path}`);
      }
    }
  };

  return (
    <div className={`d-flex flex-column inner-height game-categories-landing game-categories-landing--${variant}`}>
      <SceneBackground />
      <GamesNavbar />

      <div className="container-xl flex-grow-1 game-categories-content">
        <div className="game-categories-hero as-theme text-center mt-4 mb-4">
          <div className="game-categories-mascot" aria-hidden="true">{mascot}</div>
          <h1 className="game-categories-title">
            <span className="game-categories-title-text">{t("games.categories.title")}</span>
          </h1>
          <p className="game-categories-subtitle">{t("games.categories.subtitle")}</p>
          <div className="game-categories-emoji-row" aria-hidden="true">
            🎮 🎲 🎯 🃏 🌿 🌳
          </div>
        </div>

        <div className="row g-4 pb-5">
          {gameCategories.map((category, idx) => (
            <div key={category.titleKey} className="col-12 col-md-6 col-lg-4">
              <button
                type="button"
                className={`game-card ${category.comingSoon ? 'coming-soon' : ''}`}
                onClick={() => handleCategoryClick(category)}
                disabled={category.comingSoon}
                style={{ animationDelay: `${idx * 60}ms` }}
              >
                <div className="game-card-icon">{category.icon}</div>
                <div className="game-card-title">{t(category.titleKey)}</div>
                <div className="game-card-description">{t(category.descriptionKey)}</div>
                {category.comingSoon && (
                  <div className="coming-soon-badge">{t("games.categories.coming_soon")}</div>
                )}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
